module.exports = __webpack_public_path__ + "static/media/15UN-Habitat6.e580e5ab.jpg";